import { defineMessages } from 'react-intl';

export default defineMessages({
  menuEditor: {
    id: 'sku-menu-page--title-menu-editor',
    defaultMessage: 'Menu editor',
  },
  menu: {
    id: 'sku-menu-page--title-menu',
    defaultMessage: 'Menu',
  },
  comingSoon: {
    id: 'sku-menu-page--coming-soon',
    defaultMessage: 'Coming soon',
  },
  noMenusTitle: {
    id: 'sku-menu-page--empty-state-title',
    defaultMessage: 'Welcome to your menu editor!',
  },
  noMenusSubtitle: {
    id: 'sku-menu-page--empty-state-subtitle',
    defaultMessage: 'Add a menu to get started',
  },
  noCategories: {
    id: 'sku-menu-page--no-categories',
    defaultMessage: 'No categories in this menu yet.',
  },
  menuSelectorLabel: {
    id: 'sku-menu-page--menu-selector-label',
    defaultMessage: 'Menu',
  },
  itemsTab: {
    id: 'sku-menu-page--tab-items',
    defaultMessage: 'Items',
  },
  modifiersTab: {
    id: 'sku-menu-page--tab-modifiers',
    defaultMessage: 'Modifiers',
  },
  menuLoadError: {
    id: 'sku-menu-page--menu-load-error',
    defaultMessage: 'We were unable to load your menus. Please try again.',
  },
  itemLoadError: {
    id: 'sku-menu-page--item-load-error',
    defaultMessage: 'We were unable to load your menu items. Please try again.',
  },
  addMenu: {
    id: 'sku-menu-page--add-menu',
    defaultMessage: 'Add menu',
  },
  addMenuActionLabel: {
    id: 'sku-menu-page--add-menu-action-label',
    defaultMessage: 'Add',
  },
  addItem: {
    id: 'sku-menu-page--add-item',
    defaultMessage: 'Add item',
  },
  addItemActionLabel: {
    id: 'sku-menu-page--add-item-action-label',
    defaultMessage: 'Add item',
  },
  addCategory: {
    id: 'sku-menu-page--add-category',
    defaultMessage: 'Add category',
  },
  addCategoryActionLabel: {
    id: 'sku-menu-page--add-category-action-label',
    defaultMessage: 'Add category',
  },
  menuCreateSuccess: {
    id: 'sku-menu-page--menu-create-success',
    defaultMessage: '{menuName} menu was successfully added',
  },
  menuCreateErrorTitle: {
    id: 'sku-menu-page--menu-create-error-title',
    defaultMessage: 'We were unable to add your menu',
  },
  menuSettingsAriaLabel: {
    id: 'sku-menu-page--menu-settings-aria-label',
    defaultMessage: 'Menu settings',
  },
  editMenu: {
    id: 'sku-menu-page--edit-menu',
    defaultMessage: 'Edit menu',
  },
  viewMenu: {
    id: 'sku-menu-page--view-menu',
    defaultMessage: 'View menu',
  },
  menuUpdateSuccess: {
    id: 'sku-menu-page--menu-update-success',
    defaultMessage: '{menuName} menu was successfully updated',
  },
  menuUpdateErrorTitle: {
    id: 'sku-menu-page--menu-update-error-title',
    defaultMessage: 'We were unable to update your menu',
  },
  menuEmptyTitle: {
    id: 'sku-menu-page--menu-empty-title',
    defaultMessage: 'Your items will appear here',
  },
  menuEmptySubtitle: {
    id: 'sku-menu-page--menu-empty-subtitle',
    defaultMessage: 'Add your other menus, or start adding categories and items to this one.',
  },
  itemStatusChangeSuccess: {
    id: 'sku-menu-page--item-status-change-success',
    defaultMessage: '<strong>{itemName}</strong> availability updated',
  },
  itemStatusChangeError: {
    id: 'sku-menu-page--item-status-change-error',
    defaultMessage: '<strong>We were unable to update item availability</strong>',
  },
  itemLabel: {
    id: 'sku-menu-page--item-label',
    defaultMessage: 'Item',
  },
  allDays: {
    id: 'sku-menu-page--all-days',
    defaultMessage: 'All days',
  },
  disableCategoryConfirmTitle: {
    id: 'sku-menu-page--disable-category-confirm-title',
    defaultMessage: 'Disable <strong>{categoryName}</strong>?',
  },
  disableCategoryConfirmDescription: {
    id: 'sku-menu-page--disable-category-confirm-description',
    defaultMessage:
      'Items in this category will no longer be visible to customers. You can re-enable this category at any time.',
  },
  disableCategoryConfirmCancel: {
    id: 'sku-menu-page--disable-category-confirm-cancel',
    defaultMessage: 'Cancel',
  },
  disableCategoryConfirmAction: {
    id: 'sku-menu-page--disable-category-confirm-action',
    defaultMessage: 'Disable category',
  },
  disableCategoryDialogLabel: {
    id: 'sku-menu-page--disable-category-dialog-label',
    defaultMessage: 'Disable category',
  },
  categoryDisableSuccess: {
    id: 'sku-menu-page--category-disable-success',
    defaultMessage: '<strong>{categoryName}</strong> has been disabled',
  },
  categoryDisableError: {
    id: 'sku-menu-page--category-disable-error',
    defaultMessage: '<strong>We were unable to disable your category</strong>',
  },
  categoryEnableSuccess: {
    id: 'sku-menu-page--category-enable-success',
    defaultMessage: '<strong>{categoryName}</strong> has been enabled',
  },
  categoryEnableError: {
    id: 'sku-menu-page--category-enable-error',
    defaultMessage: '<strong>We were unable to enable your category</strong>',
  },
  closedDates: {
    id: 'sku-menu-page--closed-dates',
    defaultMessage: 'Add closed dates',
  },
  viewClosedDates: {
    id: 'sku-menu-page--view-closed-dates',
    defaultMessage: 'View closed dates',
  },
  businessProfile: {
    id: 'sku-menu-page--business-profile',
    defaultMessage: 'Business Profile',
  },
  viewBusinessProfile: {
    id: 'sku-menu-page--view-business-profile',
    defaultMessage: 'View business profile',
  },
  hideMenu: {
    id: 'sku-menu-page--hide-menu',
    defaultMessage: 'Hide menu',
  },
  showMenu: {
    id: 'sku-menu-page--show-menu',
    defaultMessage: 'Show menu',
  },
  removeItemDialogLabel: {
    id: 'sku-menu-page--remove-item-dialog-label',
    defaultMessage: 'Remove item from category',
  },
  removeItemFromCategoryTitle: {
    id: 'sku-menu-page--remove-item-from-category-title',
    defaultMessage: 'Remove <strong>{itemName}</strong> from {categoryName}?',
  },
  removeItemTitle: {
    id: 'sku-menu-page--remove-item-title',
    defaultMessage: 'Remove <strong>{itemName}</strong>?',
  },
  removeItemFromCategoryDescription: {
    id: 'sku-menu-page--remove-item-from-category-description',
    defaultMessage: 'Choose whether to remove this item from this category only, or from all menus.',
  },
  removeItemDescription: {
    id: 'sku-menu-page--remove-item-description',
    defaultMessage: 'This item will be removed from this category. It will remain available to add back later.',
  },
  removeFromThisCategory: {
    id: 'sku-menu-page--remove-from-this-category',
    defaultMessage: 'Remove from this category',
  },
  removeFromAllMenus: {
    id: 'sku-menu-page--remove-from-all-menus',
    defaultMessage: 'Remove from all menus',
  },
  removeItemCancel: {
    id: 'sku-menu-page--remove-item-cancel',
    defaultMessage: 'Cancel',
  },
  removeItemConfirmAction: {
    id: 'sku-menu-page--remove-item-confirm-action',
    defaultMessage: 'Remove',
  },
  removeItemSuccess: {
    id: 'sku-menu-page--remove-item-success',
    defaultMessage: '<strong>{itemName}</strong> removed from category',
  },
  removeFromAllMenusSuccess: {
    id: 'sku-menu-page--remove-from-all-menus-success',
    defaultMessage: '<strong>{itemName}</strong> removed from all menus',
  },
  removeItemError: {
    id: 'sku-menu-page--remove-item-error',
    defaultMessage: '<strong>We were unable to remove your item</strong>',
  },
});
